import React from "react";
import PropTypes from "prop-types";
import Svg from "../svg/Svg";
import classNames from "classnames";
import { svgIcons } from "./icons";
class Icon extends React.Component {
    render() {
        if (!this.props.icon) {
            return null;
        }
        const ico = svgIcons.get(this.props.icon);
        if (!ico) {
            console.warn(`${this.props.icon} not found`);
            return null;
        }
        const size = this.props.size || ico.size;
        let style = {};
        if (size) {
            style = Object.assign(Object.assign({}, style), { width: `${size}px`, height: `${size}px` });
        }
        if (ico.yOffset) {
            style = Object.assign(Object.assign({}, style), { transform: `translateY(${ico.yOffset}px)` });
        }
        if (ico.xOffset) {
            style = Object.assign(Object.assign({}, style), { transform: `translateX(${ico.xOffset}px)` });
        }
        const className = classNames("gui-icon", this.props.fillColor || this.props.fillColor !== "default" ? `gui-icon--${this.props.fillColor}` : null, {
            "gui-icon--block": this.props.block,
            "gui-icon--circle": this.props.circle,
            "gui-icon--circle-red": this.props.circleColor === "red",
            "gui-icon--circle-gray": this.props.circleColor === "gray",
            "gui-icon--colorizeBy-stroke": ico.colorizeBy === "stroke",
            "gui-icon--colorizeBy-fillAndStroke": ico.colorizeBy === "fillAndStroke"
        });
        return React.createElement(Svg, { src: ico.svg, className: className, style: style });
    }
}
Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    title: PropTypes.string
};
export default Icon;
//# sourceMappingURL=Icon.js.map